import { API, graphqlOperation } from "aws-amplify";
import {
  GET_MY_SOUND,
  GET_MY_SOUND_FAIL,
  GET_MY_SOUND_SUCCESS,
} from "../../components/core/SoundsOfEnglish/FeatureCourse/constants";
import { GetMySounds } from "../../queries";

export const getMySounds = (userId: string) => {
  return async (dispatch: any) => {
    dispatch({ type: GET_MY_SOUND });
    const getMySoundDetails = API.graphql(graphqlOperation(GetMySounds, { userId })) as Promise<any>;
    getMySoundDetails
      .then(async (getMySoundContents: any) => {
        if (getMySoundContents && getMySoundContents.data) {
          dispatch({
            type: GET_MY_SOUND_SUCCESS,
            payload: JSON.parse(getMySoundContents.data.getMySounds),
          });
        } else {
          dispatch({
            type: GET_MY_SOUND_FAIL,
            error: {
              message: "Something went wrong",
            },
          });
        }
      })
      .catch((err: any) => {
        dispatch({
          type: GET_MY_SOUND_FAIL,
          error: {
            message: err,
          },
        });
      });
  };
};
